import { render, staticRenderFns } from "./CrudFactory.vue?vue&type=template&id=49b50f7a&scoped=true&"
import script from "./CrudFactory.vue?vue&type=script&lang=js&"
export * from "./CrudFactory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b50f7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
